if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.quantityHandler();
    }

    quantityHandler() {
      this.quantitySelector = this.form.querySelector('quantity-input');

      if (!this.quantitySelector) return;

      this.quantitySelectorInput = this.quantitySelector.querySelector('input');

      if (!this.quantitySelectorInput) return;

      this.quantitySelector.addEventListener('change', () => {
        this.submitButton.setAttribute('aria-disabled', false);

        if (+this.quantitySelectorInput.value > +this.quantitySelectorInput.max) {
          this.submitButton.setAttribute('aria-disabled', true);
        }
      });
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      let enablePromo = promoCampaignSettings.enablePromo == 'true';
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      if (this.submitButton.dataset.custom == 'true') {
        const chatBtn = document.querySelector('#chat-button');
        chatBtn.contentDocument.querySelector('#gorgias-chat-messenger-button').click();
        return;
      }

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');

      const formData = new FormData(this.form);

      const uniqueID = (Math.random() + 1).toString(36).substring(7);
      const properties = {};
      const propertiesIDs = [];
      const items = [];
      let missOtherProperties = false;

      for (const [key, value] of formData) {
        if (key.includes('display') && value) {
          items.push({
            'id': value,
            'quantity': 1
          });
        }
        if (key.includes('properties')) {
          const str = key.split('[')[1].split(']')[0];
          if (str != "_grouping" && str != window.variantStrings.preOrder) {
            properties[str] = +value;
          } else {
            properties[str] = value;
          }
          if (str != "_grouping" && str != "Ring Size" && str != "Pre-order item" && str != "In Stock item") {
            propertiesIDs.push(value);
          }
          if (str == window.variantStrings.preOrder) {
            missOtherProperties = true;
          }
        }
      }

      if (propertiesIDs.length > 0 && !missOtherProperties) {
        properties['_unique_ID'] = uniqueID;
      }

      const subItems = propertiesIDs.map(el => {
         if (missOtherProperties) {
          return;
        }
        return {
          'id': el,
          'quantity': formData.get('quantity') ? formData.get('quantity') : 1,
          'properties': {
            '_product_id': +formData.get('id'),
            '_unique_ID': uniqueID,
            '_for': this.closest('.product-info__wrapper').querySelector('[data-product-title]').getAttribute('data-product-title'),
          }
        }
      });

      // promo campaign
      if (enablePromo) {
        const productCollections = JSON.parse(this.querySelector('[data-collection="collection"]').textContent);
        let isProductInPromoCollection = false;
        const $cartItems = document.querySelector('cart-drawer').querySelectorAll('[type="application/json"][data-item-type="main"]');
        const freeProduct = {
          'id': promoCampaignSettings.freeGiftProductId,
          'quantity': '1',
          'properties': {
            '_free_product': true,
            '_related_product_id': formData.get('id'),
            '_unique_ID': uniqueID,
            '_for': this.closest('.product-info__wrapper').querySelector('[data-product-title]').getAttribute('data-product-title'),
          }
        };
        const promoCollections = promoCampaignSettings.promoCollections.split(',');
        promoCollections.splice(0,1);
        promoCollections.every((collection) => {
          if (productCollections.find((el) => el.handle == collection)) {
            isProductInPromoCollection = true;
            return false;
          } else {
            return true;
          }
        });

        if (isProductInPromoCollection) {
          const isProductInTheCart = Array.from($cartItems).find(($data) => {
            return +JSON.parse($data.textContent).variant_id == +promoCampaignSettings.freeGiftProductId;;
          });

          if (!isProductInTheCart) {
            items.push(freeProduct);
            if (!properties['_unique_ID']) properties['_unique_ID'] = uniqueID;
            properties['_free_gift'] = promoCampaignSettings.freeGiftProductId;
          };
        }

        enablePromo = false;
      }

      if (subItems.length > 0) items.push(...subItems);
      items.push({
        'id': formData.get('id'),
        'quantity': formData.get('quantity') ? formData.get('quantity') : 1,
        'properties': {
          ...properties,
        }
      });

      const addToCartData = {
        'items': items,
        'sections': this.cart.getSectionsToRender().map((section) => section.id),
        'sections_url': window.location.pathname
      };

      if (this.cart) {
        this.cart.setActiveElement(document.activeElement);
      }

      const body = JSON.stringify(addToCartData);

      fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body }})
        .then((response) => response.json())
        .then((response) => {
          if (response.errors) {
            this.handleErrorMessage(response.errors);
            this.submitButton.setAttribute('aria-disabled', true);
            this.error = true;
            return;
          } else {
            if(!this.cart) {
              window.location = window.routes.cart_url;
              return response.json();
            }
          }

          this.error = false;

          const quickViewModal = document.querySelector('.quick-view-modal');
          if (quickViewModal) {
            quickViewModal.classList.remove('quick-view-modal--open');
            document.querySelector('body').classList.remove('overflow-hidden');
          }

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          window.dispatchEvent(new CustomEvent(
            'product_added_to_cart',
            {
              detail: {
                id: formData.get('id'),
                quantity: formData.get('quantity'),
                items:items
              }
            })
          );
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
